import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const BinocularsIcon: FC<IconProps> = ({color = theme.palette.text.default, size}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.78893 13.5558L7.78893 5.34999C7.78893 4.23999 6.88977 3.34082 5.77977 3.34082V3.34082C4.86393 3.34082 4.06477 3.95999 3.83477 4.84582L1.75977 12.8542"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.8931 11.4401C8.08876 12.6357 8.08876 14.5743 6.8931 15.7699C5.69744 16.9656 3.75891 16.9656 2.56325 15.7699C1.36759 14.5743 1.36759 12.6357 2.56325 11.4401C3.75891 10.2444 5.69744 10.2444 6.8931 11.4401"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M12.2109 13.5558L12.2109 5.34999C12.2109 4.23999 13.1101 3.34082 14.2201 3.34082V3.34082C15.1359 3.34082 15.9351 3.95999 16.1651 4.84582L18.2401 12.8542"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2107 8.33335C12.2107 7.11001 11.2207 6.11835 9.9999 6.11835C8.77906 6.11835 7.78906 7.11001 7.78906 8.33335"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.78906 13.3333C7.78906 12.11 8.77906 11.1183 9.9999 11.1183C11.2207 11.1183 12.2107 12.11 12.2107 13.3333"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4366 11.4401C18.6322 12.6357 18.6322 14.5743 17.4366 15.7699C16.2409 16.9656 14.3024 16.9656 13.1067 15.7699C11.911 14.5743 11.911 12.6357 13.1067 11.4401C14.3024 10.2444 16.2409 10.2444 17.4366 11.4401"
          stroke={color}
          strokeWidth="1.5"
        />
      </svg>
    </Icon>
  </>
)
